import { render, staticRenderFns } from "./businessTripApply.vue?vue&type=template&id=2ecffc91&"
import script from "./businessTripApply.vue?vue&type=script&lang=js&"
export * from "./businessTripApply.vue?vue&type=script&lang=js&"
import style0 from "./businessTripApply.vue?vue&type=style&index=0&id=2ecffc91&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports